import { gql, useLazyQuery } from "@apollo/client";
import React, { useCallback, useState } from "react";
import { usePicklists } from "ticketing/contexts/picklists/PicklistContextProvider";
import { GqlResponse, TBatch } from "ticketing/ticketing.types";

// for type ahead
export const GQL = gql`
  query batchesFilterBy($enterpriseSystemId: Int!, $name: String!) {
    batches: batchesFilterBy(filter: { enterpriseSystemId: $enterpriseSystemId, name: { regexIgnoreCase: $name } }) {
      id
      name
      logisticsSystem{
        id
        name
      }
      modeOfTransport {
        name
      }
    }
  }
`;

const delay = 500;
type Response = GqlResponse<TBatch[], "batches">;

const useSearchBatches = () => {
  const { picklists } = usePicklists();
  const [searchResults, setSearchResults] = useState<TBatch[]>([]);

  const [filter, { loading, error }] = useLazyQuery<Response>(GQL, {
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    onCompleted: (data) => setSearchResults(data.batches),
  });

  const timeout = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  const search = (name: string) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      filter({ variables: { enterpriseSystemId: picklists?.enterpriseSystemId, name: `%${name}%` } });
    }, delay);
  };

  const clear = useCallback(() => {
    setSearchResults([]);
  }, [setSearchResults]);
  return [search, searchResults, loading, error, clear] as const;
};

export default useSearchBatches;
